import React from "react"

import { Wrapper, Row, ColWithBg, Content } from "../pageElements"

export const Reviews = () => {
  return (
    <Wrapper>
      <Row height={20}>
        <ColWithBg>
          <Content center>REVIEWS</Content>
        </ColWithBg>
      </Row>
    </Wrapper>
  )
}
